module.exports = __webpack_public_path__ + "img/advantage2Green.dd209fba.png";